import 'bootstrap';
import 'core-js';
import 'regenerator-runtime/runtime';
import { initializeClearInput } from './clear-input';
import { initializeFilterDropdown } from './filter-dropdown';
import { initializeNavbarSearch } from './navbar-search';
import { initializePasswordShowHide } from './password-show-hide';
import { initializeResourceDropdown } from './resource-dropdown';
import { initializeSelectDropdown } from './select-dropdown';
import { initializeSwiperCarousel } from './swiper-carousel';
import { initializeTabsDropdown } from './tabs-dropdown';
import { initializeTabGroup } from './tab-group';
import { initializeFilterHeader } from './filter-header';
import { initializeResourcesPublicationsFilters } from './resources-publications-filters';
import { initializeHeaderNav } from './header-nav';
import { initializeRichText } from './rich-text';
import { initializeSplitContent } from './split-content';
import { initializeReactForm } from '../components/react-form-root';
import { initializeEventsList } from '../components/react-events-root';
import { initializeProductSearch } from './product-search';
import { initializeCrmForm } from './crm-form';

export function initialize() {
  initializeClearInput();
  initializeFilterDropdown();
  initializeNavbarSearch();
  initializePasswordShowHide();
  initializeResourceDropdown();
  initializeSelectDropdown();
  initializeSwiperCarousel();
  initializeTabsDropdown();
  initializeTabGroup();
  initializeFilterHeader();
  initializeResourcesPublicationsFilters();
  initializeHeaderNav();
  initializeRichText();
  initializeSplitContent();
  initializeReactForm();
  initializeEventsList();
  initializeProductSearch();
  initializeCrmForm();
}
